const formatCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/\D/g, "");

  cnpj = cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );

  return cnpj;
};

const maskCnpj = {
  bind(el, binding, vnode) {
    el.addEventListener("input", function(event) {
      let value = event.target.value;

      if (value.length > 14) {
        value = value.slice(0, 14);
      }

      vnode.context.itensForm.cnpj = formatCNPJ(value);
    });
  },
};

export default {
  install(Vue) {
    Vue.directive("mask-cnpj", maskCnpj);
  },
};
